import { useContext } from 'react'
import { WppButton, WppToggle, WppSkeleton } from '@wppopen/components-library-react'
import ViewTaskPageContext from 'context/viewTaskPageContext/viewTaskPageContext'
import { ButtonSkeleton } from 'components/Skeletons'
import type { JobsDetailData } from '@contracts'
import styles from './PdpContentActions.module.scss'

interface PdpContentActionsProps {
  jobStatus: JobsDetailData['status']
  isInitialising?: boolean
  toggleActions: {
    isActive: boolean
    onChange: () => void
  }
  editActions: {
    isActive: boolean
    onClick: () => void
  }
}

export default function PdpContentActions({
  jobStatus,
  toggleActions,
  editActions,
  isInitialising,
}: PdpContentActionsProps) {
  const { isPageEditable } = useContext(ViewTaskPageContext)

  const shouldShowKeywordsToggle =
    jobStatus !== 'failed' && jobStatus !== 'processing' && jobStatus !== 'blocked' && jobStatus !== 'executing'

  return (
    <div className={styles.action_container} data-testid="pdp-content-actions">
      {isInitialising ? (
        <WppSkeleton variant="rectangle" width={200} height={40} data-testid="toggle-keywords-skeleton" />
      ) : (
        shouldShowKeywordsToggle && (
          <WppToggle
            required
            data-testid="toggle-keywords"
            labelConfig={{
              text: 'Show Keywords & Phrases',
            }}
            checked={toggleActions.isActive}
            onWppChange={toggleActions.onChange}
          />
        )
      )}

      {isInitialising ? (
        <ButtonSkeleton />
      ) : (
        jobStatus === 'completed' && (
          <WppButton
            className={styles.button}
            data-testid="edit-button"
            variant="secondary"
            disabled={editActions.isActive}
            onClick={editActions.onClick}
          >
            {isPageEditable ? 'Cancel edit' : 'Edit'}
          </WppButton>
        )
      )}
    </div>
  )
}
